module.exports = __webpack_public_path__ + "img/P.615df940.jpg";